import React from 'react';
import { useTranslation } from 'react-i18next';
import { MoneyView } from '../MoneyView';
import { Box, Typography } from '@utex/ui-kit';
import { useBalance } from '../../hooks/useBalance';
import { style } from './styles';

interface Props {
  currency: string;
  onClick?: () => void;
}

export const Balance: React.FC<Props> = ({ currency, onClick }) => {
  const { t } = useTranslation('conversion');

  const { balance, loading } = useBalance(currency);

  return (
    <Box display="flex" flexDirection="column" onClick={onClick} css={style}>
      <Typography.Text>{t('Maximum')}</Typography.Text>
      <Typography.Text>{loading ? <>...</> : <MoneyView>{balance}</MoneyView>}</Typography.Text>
    </Box>
  );
};
